import Icon from '../components/Icon.vue'

Icon.register({
  'x-ray': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M240 384c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zM400 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM624 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h608zM624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h48v-352h512v352h48zM480 248v-16c0-4.4-3.6-8-8-8h-136v-32h104c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-104v-24c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v24h-104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h104v32h-136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h136v32h-104c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h104v32h-64c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48v-16h64v16c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48h-64v-32h104c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-104v-32h136c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})
